






import { Component, Vue } from "vue-property-decorator";
import InjectionAuditList from "@/components/ppi/injection-audit/InjectionAuditList.vue";

@Component({
  components: { InjectionAuditList }
})
export default class InjectionAuditPage extends Vue {}
